import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-background-animation',
  templateUrl: './background-animation.component.html',
  styleUrls: ['./background-animation.component.scss']
})
export class BackgroundAnimationComponent implements OnInit {
  waves: number[] = Array(10).fill(0);
  isMobile: boolean = false;

  constructor(private breakpointObserver: BreakpointObserver, @Inject(PLATFORM_ID) private platformId: Object) {

    this.breakpointObserver.observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape, Breakpoints.TabletPortrait])
      .subscribe(result => {
        this.isMobile = result.matches;
      });

  }

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
    }
  }
}